export enum DataStoreTypeEnum {
  Public = 0,
  Private = 1,
  Shared = 2,
}
